import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router, { initRouterGuards } from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'


import { initFirebase, useFirebase } from './services/firebase'
import { onAuthStateChanged } from 'firebase/auth'

async function bootstrap() {
  //Inicializa Firebase primero
  await initFirebase()
  const { auth } = useFirebase()
  initRouterGuards(auth)
  //Crea la app UNA sola vez
  const app = createApp(App)
  app.use(stores)
  
  app.use(i18n)
  app.use(createVuestic({ config: vuesticGlobalConfig }))

  if (import.meta.env.VITE_APP_GTM_ENABLED) {
    app.use(
      createGtm({
        id: import.meta.env.VITE_APP_GTM_KEY,
        debug: false,
        vueRouter: router,
      }),
    )
  }

  //Espera al estado de auth SOLO para decisiones de navegación
  onAuthStateChanged(auth, () => {
    app.use(router)
    app.mount('#app')
  })
}

bootstrap()